import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class HeaderService {

  navchange: any = new EventEmitter();

  constructor() { }

  emitNavChangeEvent(value: any) {
    this.navchange.emit(value);
  }

  getNavChangeEmitter() {
    return this.navchange;
  }
}